import { firebaseFunctions } from "./firebaseConfig";
import { httpsCallable } from "firebase/functions";

export const callFirebaseFunctions = (callName: string) => {
  return httpsCallable(firebaseFunctions, callName);
};
